import React from 'react';
import VideoGridOverlay from './VideoGridOverlay';
import HoverVideoPlayer from "react-hover-video-player";

const VideoGrid = props => {
    return (
        <div className='grid lg:grid-cols-2 grid-cols-1'>
            <HoverVideoPlayer
                videoSrc={'/assets/static/videos/Dinshaw Purity Final.mp4'}
                pausedOverlay={<VideoGridOverlay url={'/assets/static/images/Video1-thumbnail.JPG'}>
                    <h3 className="text-dinshaw-blue font-heading portrait:text-sm">
                        Surety of purity,<br />
                        WRAPPED IN TRUST
                    </h3>
                    <div className='my-2'>
                    <button className='w-12 h-12 lg:w-20 lg:h-20 flex items-center justify-center portrait:hidden'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-20 h-20">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
                            </svg>
                        </button>
                        <button className='w-8 h-8 lg:w-20 lg:h-20 flex items-center justify-center landscape:hidden'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-20 h-20">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </VideoGridOverlay>}
            />

            <HoverVideoPlayer
                videoSrc={'/assets/static/videos/Dinshaw Technology Final.mp4'}
                pausedOverlay={<VideoGridOverlay url={'/assets/static/images/Video2-thumbnail.JPG'}>
                    <h3 className="text-dinshaw-blue font-bold font-heading portrait:text-sm">
                        Use Of Technology,<br />
                        WRAPPED IN EXPERTISE
                    </h3>
                    <div className='my-2'>
                        <button className='w-12 h-12 lg:w-20 lg:h-20 flex items-center justify-center portrait:hidden'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-20 h-20">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
                            </svg>
                        </button>
                        <button className='w-8 h-8 lg:w-20 lg:h-20 flex items-center justify-center landscape:hidden'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-20 h-20">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </VideoGridOverlay>}
            />
            <HoverVideoPlayer
                videoSrc={'/assets/static/videos/Dinshaw Knowledge Final.mp4'}
                pausedOverlay={<VideoGridOverlay url={'/assets/static/images/Video3-thumbnail.JPG'}>
                    <>
                        <h3 className="text-dinshaw-blue font-heading portrait:text-sm">
                            Legacy Of Knowledge,<br />
                            WRAPPED IN EXPERIENCE
                        </h3>
                        <div className='my-2'>
                        <button className='w-12 h-12 lg:w-20 lg:h-20 flex items-center justify-center portrait:hidden'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-20 h-20">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
                            </svg>
                        </button>
                        <button className='w-8 h-8 lg:w-20 lg:h-20 flex items-center justify-center landscape:hidden'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-20 h-20">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
                            </svg>
                        </button>
                        </div>
                    </>
                </VideoGridOverlay>}
            />
            <HoverVideoPlayer
                videoSrc={'/assets/static/videos/1088048885-preview.mp4'}
                pausedOverlay={<VideoGridOverlay url={'/assets/static/images/Video4-thumbnail.JPG'}>
                    <h3 className="text-dinshaw-blue font-heading portrait:text-sm">
                        Mission Of Change,<br />
                        WRAPPED IN SMILES
                    </h3>
                    <div className='my-2'>
                    <button className='w-12 h-12 lg:w-20 lg:h-20 flex items-center justify-center portrait:hidden'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-20 h-20">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
                            </svg>
                        </button>
                        <button className='w-8 h-8 lg:w-20 lg:h-20 flex items-center justify-center landscape:hidden'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-20 h-20">
                                <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z" clipRule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </VideoGridOverlay>}
            />
        </div>
    );
};

export default VideoGrid;